import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/next-view-transitions/dist/index.js");
